module.exports = __webpack_public_path__ + "img/bj_3.b6827dd1.png";